/**
 * Available administration tabs
 */
export enum AdministrationTab {
  GENERAL,
  USER,
  GROUP,
  DATA_API,
}
